import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { apiClient } from "@/api/ApiClient";
import ProductCatalog from "@/components/products/ProductCatalog/ProductCatalog";
import "./SearchResultsPage.css";
const SearchResultsPage = () => {
    const location = useLocation();
    const [results, setResults] = useState([]);
    const [loading, setLoading] = useState(true);
    const [searchQuery, setSearchQuery] = useState("");
    useEffect(() => {
        const query = new URLSearchParams(location.search).get("query") || "";
        setSearchQuery(query);
        if (query) {
            setLoading(true);
            apiClient
                .searchData("name", query)
                .then((response) => {
                setResults(response);
                setLoading(false);
            })
                .catch((error) => {
                console.error("Search error:", error);
                setLoading(false);
            });
        }
        else {
            setResults([]);
            setLoading(false);
        }
    }, [location.search]);
    if (loading) {
        return _jsx("div", { className: "loading-container", children: "Loading..." });
    }
    return (_jsx("div", { className: "main-container", children: _jsxs("div", { className: "search-results-container", children: [_jsx("h2", { className: "search-results-title", children: results.length === 0
                        ? `No results found for "${searchQuery}"`
                        : `Search Results for "${searchQuery}" (${results.length})` }), _jsx(ProductCatalog, { propsLimit: results.length, propsSort: "name-asc", propsProducts: results })] }) }));
};
export default SearchResultsPage;
